// src/shared/api/fetcher.ts
import { axiosInstance } from './client';
import { registerInterceptors } from './interceptors';

// Install the axios interceptors. Idempotent — fetcher, mutator and upload
// each call it, and only the first one does the work.
registerInterceptors();

export default function fetcher<T = unknown>(url: string, options?: { signal?: AbortSignal }): Promise<T> {
  return axiosInstance.get<T>(url, options).then((res) => res.data);
}
